import tw, { styled } from 'twin.macro';

export const MainWrapper = styled.div<{ fullheight?: boolean }>`
  ${tw`w-full max-h-[90vh]`}
  ${({ fullheight }) => (fullheight ? tw`h-[90%]` : tw``)}
`;
export const HeaderWrapper = styled.div`
  ${tw`hidden lg:flex border-b border-neutral-40 w-full justify-between items-center py-[10.5px] px-4 lg:(p-3 pl-10)`}
`;
export const HeaderContentWrapper = styled.div`
  ${tw``}
`;
export const BodyWrapper = styled.div<{ fullheight?: boolean }>`
  ${tw`lg:(flex)`}
  ${({ fullheight }) => (fullheight ? tw`h-full` : tw``)}
`;
export const MainContentAndFooterWrapper = styled.div<{ fullheight?: boolean; isDefaultView?: boolean }>`
  ${tw`w-full relative lg:(overflow-y-auto)`}
  ${({ fullheight }) => (fullheight ? tw`h-full` : tw``)}
  ${({ isDefaultView }) => (isDefaultView ? tw`md:h-[calc(100vh-184px)]` : tw`lg:h-[calc(100vh - 120px)]`)}
`;
export const MainContentWrapper = styled.div<{ fullheight?: boolean }>`
  ${tw`pt-2 px-5 lg:(pt-5 px-10)`}
  ${({ fullheight }) => (fullheight ? tw`h-full` : tw``)}
`;
export const MainContentFooterWrapper = styled.div`
  ${tw`bottom-0 left-0 right-0 py-2 px-5 lg:(py-8 px-10 h-fit)`}
`;
export const SidePanelWrapper = styled.div`
  ${tw`p-2 mt-0 lg:(w-[320px] min-w-[320px] h-[calc(100vh - 120px)] border-l border-neutral-40 p-5 mt-0) hidden lg:block`}
`;

export const ModalHeaderContentWrapper = styled.div`
  ${tw`flex items-center gap-4`}
`;
export const CandidateNameWrapper = styled.div`
  ${tw`flex gap-2`}
`;
export const SideContentWrapper = styled.div<{ isSpontaneous?: boolean }>`
  ${tw`flex flex-col gap-5`}
`;
export const BadgesWrapper = styled.div`
  ${tw`flex items-center gap-3`}
`;
export const LogoWrapper = styled.div`
  ${tw` border border-neutral-40 rounded-lg relative w-10 h-10 min-w-[2.5rem] flex items-center justify-center object-cover object-center overflow-hidden bg-white`}
`;
export const AppliedToContentWrapper = styled.div`
  ${tw`bg-neutral-30 p-4 w-full flex flex-col gap-2 rounded-lg mt-3 lg:(flex-row gap-4)`}
`;
export const RestaurantInfoWrapper = styled.div`
  ${tw`truncate`}
`;
export const CandidateModalSectionTitle = styled.h3`
  ${tw`text-lg text-[#000000] font-semibold mb-4`}
`;
